<template>
    <v-sheet outlined rounded v-bind="{ loading }">
        <v-list-item class="py-2">
            <v-list-item-avatar color="grey lighten-3" rounded size="64">
                <v-img :src="material?.photo">
                    <template #placeholder>
                        <v-icon large color="grey">mdi-image-broken-variant</v-icon>
                    </template>
                </v-img>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-subtitle> {{ material.maker || "-" }} </v-list-item-subtitle>
                <v-list-item-title> {{ material.code }} </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="$scopedSlots['actions']">
                <slot name="actions" />
            </v-list-item-action>
        </v-list-item>
    </v-sheet>
</template>

<script>
import { initManufacturingMaterial } from "@/assets/variables";
export default {
    props: {
        loading: { type: Boolean, default: false },
        material: { type: Object, default: initManufacturingMaterial },
    },
};
</script>

<style></style>
